(function() {
  var Client, Promise, makeOnErrorHandler, merge;

  require('./internal/compat');

  merge = require('./internal/merge');

  Promise = require('./internal/promise');

  makeOnErrorHandler = function(notifier) {
    return function(message, file, line, column, error) {
      if (error) {
        return notifier.notify(error);
      } else {
        return notifier.notify({
          error: {
            message: message,
            fileName: file,
            lineNumber: line,
            columnNumber: column || 0
          }
        });
      }
    };
  };

  Client = (function() {
    function Client(opts) {
      var reporter;
      if (opts == null) {
        opts = {};
      }
      this._projectId = opts.projectId || 0;
      this._projectKey = opts.projectKey || '';
      this._host = opts.host || 'https://api.airbrake.io';
      this._processor = null;
      this._reporters = [];
      this._filters = [];
      if (opts.processor !== void 0) {
        this._processor = opts.processor;
      } else {
        this._processor = require('./processors/stack');
      }
      if (opts.reporter !== void 0) {
        this.addReporter(opts.reporter);
      } else {
        if ('withCredentials' in new global.XMLHttpRequest()) {
          reporter = 'compat';
        } else {
          reporter = 'jsonp';
        }
        this.addReporter(reporter);
      }
      this.addFilter(require('./internal/default_filter'));
      this.onerror = makeOnErrorHandler(this);
      if ((global.onerror == null) && opts.onerror !== false) {
        global.onerror = this.onerror;
      }
    }

    Client.prototype.setProject = function(id, key) {
      this._projectId = id;
      return this._projectKey = key;
    };

    Client.prototype.setHost = function(host) {
      return this._host = host;
    };

    Client.prototype.addContext = function(context) {
      if (typeof console !== "undefined" && console !== null) {
        if (typeof console.warn === "function") {
          console.warn('airbrake: addContext is deprecated, please use addFilter');
        }
      }
      return this.addFilter(function(notice) {
        notice.context = merge({}, context, notice.context);
        return notice;
      });
    };

    Client.prototype.setEnvironmentName = function(envName) {
      if (typeof console !== "undefined" && console !== null) {
        if (typeof console.warn === "function") {
          console.warn('airbrake: setEnvironmentName is deprecated, please use addFilter');
        }
      }
      return this.addFilter(function(notice) {
        if (notice.context.environment == null) {
          notice.context.environment = envName;
        }
        return notice;
      });
    };

    Client.prototype.addParams = function(params) {
      if (typeof console !== "undefined" && console !== null) {
        if (typeof console.warn === "function") {
          console.warn('airbrake: addParams is deprecated, please use addFilter');
        }
      }
      return this.addFilter(function(notice) {
        notice.params = merge({}, params, notice.params);
        return notice;
      });
    };

    Client.prototype.addEnvironment = function(env) {
      if (typeof console !== "undefined" && console !== null) {
        if (typeof console.warn === "function") {
          console.warn('airbrake: addEnvironment is deprecated, please use addFilter');
        }
      }
      return this.addFilter(function(notice) {
        notice.environment = merge({}, env, notice.environment);
        return notice;
      });
    };

    Client.prototype.addSession = function(session) {
      if (typeof console !== "undefined" && console !== null) {
        if (typeof console.warn === "function") {
          console.warn('airbrake: addSession is deprecated, please use addFilter');
        }
      }
      return this.addFilter(function(notice) {
        notice.session = merge({}, session, notice.session);
        return notice;
      });
    };

    Client.prototype.addReporter = function(reporter) {
      switch (reporter) {
        case 'compat':
          reporter = require('./reporters/compat');
          break;
        case 'xhr':
          reporter = require('./reporters/xhr');
          break;
        case 'jsonp':
          reporter = require('./reporters/jsonp');
      }
      return this._reporters.push(reporter);
    };

    Client.prototype.addFilter = function(filter) {
      return this._filters.push(filter);
    };

    Client.prototype.notify = function(err) {
      var defContext, promise, ref;
      defContext = {
        language: 'JavaScript',
        sourceMapEnabled: true
      };
      if ((ref = global.navigator) != null ? ref.userAgent : void 0) {
        defContext.userAgent = global.navigator.userAgent;
      }
      if (global.location) {
        defContext.url = String(global.location);
        defContext.rootDirectory = global.location.protocol + '//' + global.location.host;
      }
      promise = new Promise();
      this._processor(err.error || err, (function(_this) {
        return function(processorName, errInfo) {
          var filterFn, j, k, len, len1, n, notice, opts, ref1, ref2, reporterFn;
          notice = {
            errors: [errInfo],
            context: merge(defContext, err.context),
            params: err.params || {},
            environment: err.environment || {},
            session: err.session || {}
          };
          notice.context.notifier = {
            name: 'airbrake-js-' + processorName,
            version: '0.5.9',
            url: 'https://github.com/airbrake/airbrake-js'
          };
          ref1 = _this._filters;
          for (j = 0, len = ref1.length; j < len; j++) {
            filterFn = ref1[j];
            n = filterFn(notice);
            if (n === null || n === false) {
              return;
            }
            if (n.errors != null) {
              notice = n;
            } else {
              if (typeof console !== "undefined" && console !== null) {
                if (typeof console.warn === "function") {
                  console.warn('airbrake: filter must return notice or null to ignore the notice');
                }
              }
            }
          }
          opts = {
            projectId: _this._projectId,
            projectKey: _this._projectKey,
            host: _this._host
          };
          ref2 = _this._reporters;
          for (k = 0, len1 = ref2.length; k < len1; k++) {
            reporterFn = ref2[k];
            reporterFn(notice, opts, promise);
          }
        };
      })(this));
      return promise;
    };

    Client.prototype.push = function(err) {
      if (typeof console !== "undefined" && console !== null) {
        if (typeof console.warn === "function") {
          console.warn('airbrake: push is deprecated, please use notify');
        }
      }
      return this.notify(err);
    };

    Client.prototype._wrapArguments = function(args) {
      var arg, i, j, len;
      for (i = j = 0, len = args.length; j < len; i = ++j) {
        arg = args[i];
        if (typeof arg === 'function') {
          args[i] = this.wrap(arg);
        }
      }
      return args;
    };

    Client.prototype.wrap = function(fn) {
      var airbrakeWrapper, prop, self;
      if (fn.__airbrake__) {
        return fn;
      }
      self = this;
      airbrakeWrapper = function() {
        var args, exc;
        args = self._wrapArguments(arguments);
        try {
          return fn.apply(this, args);
        } catch (_error) {
          exc = _error;
          args = Array.prototype.slice.call(arguments);
          self.notify({
            error: exc,
            params: {
              "arguments": args
            }
          });
        }
      };
      for (prop in fn) {
        if (fn.hasOwnProperty(prop)) {
          airbrakeWrapper[prop] = fn[prop];
        }
      }
      airbrakeWrapper.__airbrake__ = true;
      airbrakeWrapper.__inner__ = fn;
      return airbrakeWrapper;
    };

    return Client;

  })();

  module.exports = Client;

}).call(this);



// WEBPACK FOOTER //
// ./~/airbrake-js/lib/client.js